<template>
  <div>
    <h2>
      Manuscript Versions Submitted
      <span v-if="manuscripts.length > 0">
        &mdash;
        {{ `JMESR/${String(manuscripts[0].folder).toUpperCase()}` }}
      </span>
    </h2>

    <v-data-table
      :headers="headers"
      :items="manuscripts"
      :items-per-page="10"
      class="elevation-1 mt-5"
    >
      <template v-slot:[`item.submittedAt`]="{ item }">
        <small>{{
          item.submittedAt ? formatDate(item.submittedAt) : "NOT SUBMITTED"
        }}</small>
      </template>
      <template v-slot:[`item.manuscriptStatus`]="{ item }">
        <div v-if="item.manuscriptStatus">
          <v-chip pill small class="ma-1">
            Status:&nbsp;
            <span class="text-uppercase">{{ item.manuscriptStatus }}</span>
          </v-chip>

          <v-chip
            small
            v-if="item.decision"
            :color="decisionChip(item.decision).color"
          >
            Decision: {{ decisionChip(item.decision).decision }}&nbsp;
            <v-icon>{{ decisionChip(item.decision).icon }}</v-icon>
          </v-chip>
        </div>
        <v-chip v-else small outlined>INCOMPLETE SUBMISSION</v-chip>
      </template>
      <template v-slot:[`item.updatedAt`]="{ item }">
        <v-btn
          small
          outlined
          color="green"
          class="my-1 mr-1"
          v-if="item.submittedAt"
          :to="`/manuscripts/submitted/track/${item._id}`"
        >
          Track Manuscript
        </v-btn>
        <div v-else>
          <v-btn
            small
            outlined
            color="blue"
            class="my-1 mr-1"
            :to="`/manuscripts/continue/${item._id}`"
          >
            Continue
          </v-btn>
          <v-btn
            small
            text
            color="red"
            :disabled="deleting"
            class="my-1 mr-1"
            @click="deleteManuscript(item.folder, item._id)"
          >
            Delete
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>


<script>
import { formatDate } from "../../tools/format";
import { decisionChip } from "../../tools/decision-chip";

export default {
  props: ["folder"],
  data: () => ({
    loading: false,
    deleting: false,
    manuscripts: [],
    headers: [
      { text: "Submitted", value: "submittedAt" },
      {
        text: "Manuscript Title",
        align: "start",
        value: "title",
      },
      { text: "Manuscript Type", value: "type" },
      { text: "Manuscript Status", value: "manuscriptStatus" },
      { text: "Actions", value: "updatedAt", sortable: false },
    ],
  }),
  methods: {
    formatDate,
    decisionChip,
    fetchManuscriptFolder() {
      this.loading = true;
      this.$axios
        .get(`/manuscripts/versions/${this.folder}`)
        .then(({ data: response }) => {
          this.manuscripts = response;
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not retrieve manuscripts",
          });

          this.$router.go(-1);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteManuscript(folder, id) {
      this.deleting = true;

      this.$axios
        .delete(`/manuscript/${folder}/${id}`)
        .then(() => {
          this.$bus.$emit("manuscript.refresh");

          this.$bus.$emit("snackbar", {
            type: "info",
            message: "Manuscript deleted",
          });

          if (this.manuscripts.length > 1) {
            this.fetchManuscriptFolder();
          } else {
            this.$router.go(-1);
          }
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not delete manuscript",
          });
        })
        .finally(() => {
          this.deleting = false;
        });
    },
  },
  mounted() {
    this.fetchManuscriptFolder();
  },
};
</script>
